export enum LS {
  StatusesFilters = 'geotrack-statuses-filters',
  AnalyticsFilters = 'geotrack-analytics-filters',
}

const today = new Date();

/** Shared defaults (analytics keeps month start). Statuses page overrides dates to null. */
export const filterDefaults = {
  officeIds: [],
  unit: [],
  division: [],
  department: [],
  statuses: [],
  workFormats: [],
  jobTitles: [],
  chatbotLabels: [],
  legalOffices: [],
  professionalLevels: [],
  managerialLevels: [],
  probationStatuses: [],
  timeWorked: [],
  entryTime: [],
  entryOffice: [],
  room: [],
  workingDay: [],
  daysOfWeek: [],
  date_after: new Date(today.getFullYear(), today.getMonth(), 1),
  date_before: today,
  team: [],
  group: [],
  hrmId: '',
};
